import { styled } from "@mui/system";

export const FormContainer = styled("form")({
  padding: "20px",
});
